module.exports = __webpack_public_path__ + "static/media/Shockoe-Logo.0c9708d1.png";